import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-skip",
  "use": "icon-skip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-skip\"><path d=\"M512 42.667A469.333 469.333 0 1 0 981.333 512 469.333 469.333 0 0 0 512 42.667z m251.307 242.56L640 658.56a25.6 25.6 0 0 1-48.64-16l101.973-310.187-385.066 219.094 154.666 42.666a25.6 25.6 0 0 1 14.08 10.24l116.48 170.667a25.6 25.6 0 1 1-42.666 29.013L439.68 642.133l-205.013-58.026a25.6 25.6 0 0 1-5.76-46.934L725.333 256a25.6 25.6 0 0 1 36.907 30.293z\" p-id=\"2685\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol